export const width = 417;
export const height = 310;
export default __webpack_public_path__ + "static/3.73dccc3a.svg";